<template>
  <div class="membership-description" v-if="hasDescription">
    <h4 v-text="title" v-if="title"/>
    <p v-html="description"></p>
  </div>
</template>

<script>

import markdown from "markdown";
import {hasMetaValue, getMetaValue} from "../../utils";

export default {
  name: 'MembershipTypeDescription',
  props: {
    membershipType: {},
    title: {},
  },
  computed: {
    hasDescription() {
      return hasMetaValue(this.membershipType.metaValues, 'description');
    },
    description() {
      const metaValue = getMetaValue(this.membershipType.metaValues, 'description');
      return metaValue ? markdown.markdown.toHTML(metaValue) : null;
    },
  }
}
</script>

<style lang="scss" scoped>
.membership-description {
  max-width: 746px;;

  h4 {
    margin-top: 2rem;

  }

  margin-top: 1rem;
  font-size: 1rem;

  .membership-description h2 {
    margin-bottom: 20px;
  }

  .membership-description h4 {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 750px) {}
}
</style>